import {
    CREATE_EXTRA,
    TOGGLE_EXTRA,
} from "../actions";

const extra = (state = [], action) => {
    switch (action.type) {
    case CREATE_EXTRA:
        return {
            id: action.id,
            extraType: action.extraType,
            name: action.name,
            label: action.label,
            labelType: action.labelType,
            amount: action.amount,
            description: action.description,
            readMoreLink: action.readMoreLink,
            active: action.active,
        };
    case TOGGLE_EXTRA:
        return (state.extraType === action.extraType)
            ? { ...state, active: action.active }
            : state;
    default:
        return state
    }
}

const extras = (state = [], action) => {
    switch (action.type) {
    case CREATE_EXTRA:
        if (state.some(_extra => _extra.extraType === action.extraType)) {
            return state;
        }

        return [
            ...state,
            extra(undefined, action)
        ];
    case TOGGLE_EXTRA:
        return state.map((_extra) => extra(_extra, action));
    default:
        return state;
    }
};

export default extras;